var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line Rounded/Phone",
    clipPath: "url(#clip0_299_457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2517 17.5072L12.2608 17.5136C13.0478 18.0147 13.9823 18.2323 14.9097 18.1304C15.8372 18.0286 16.7022 17.6134 17.3617 16.9534L17.9346 16.3804C18.0616 16.2535 18.1623 16.1029 18.231 15.937C18.2998 15.7712 18.3351 15.5935 18.3351 15.414C18.3351 15.2345 18.2998 15.0567 18.231 14.8909C18.1623 14.7251 18.0616 14.5744 17.9346 14.4475L15.5181 12.0328C15.3912 11.9058 15.2405 11.8051 15.0747 11.7364C14.9089 11.6677 14.7311 11.6323 14.5516 11.6323C14.3721 11.6323 14.1944 11.6677 14.0286 11.7364C13.8627 11.8051 13.7121 11.9058 13.5852 12.0328C13.329 12.2889 12.9815 12.4328 12.6192 12.4328C12.2569 12.4328 11.9094 12.2889 11.6532 12.0328L7.78926 8.16793C7.53311 7.91171 7.38922 7.56424 7.38922 7.20194C7.38922 6.83964 7.53311 6.49217 7.78926 6.23595C7.91623 6.10907 8.01695 5.9584 8.08566 5.79258C8.15438 5.62675 8.18975 5.44901 8.18975 5.26951C8.18975 5.09001 8.15438 4.91226 8.08566 4.74644C8.01695 4.58061 7.91623 4.42995 7.78926 4.30306L5.3736 1.88832C5.11738 1.63218 4.76991 1.48828 4.40762 1.48828C4.04532 1.48828 3.69785 1.63218 3.44163 1.88832L2.86777 2.46126C2.20792 3.1209 1.79286 3.98592 1.69117 4.91338C1.58948 5.84085 1.80725 6.77525 2.30849 7.56219L2.31396 7.5713C4.96114 11.4879 8.33458 14.8607 12.2517 17.5072V17.5072Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.12207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.54dbfd11bfe794704f33c17aaf3ecc37.svg";
export { ForwardRef as ReactComponent };